import { useApiQuery } from 'hooks/useApiQuery'
const path = '/le-connect/reports/performance-trends'
const method = 'get'

interface UseGetPerformanceTrendsParams {
  licenses: string[]
  enabled?: boolean
}

export const useGetPerformanceTrends = ({
  licenses,
  enabled,
}: UseGetPerformanceTrendsParams) =>
  useApiQuery({
    path,
    method,
    enabled,
    queryKey: [path, licenses.join(',')],
    queryArgs: {
      licenses,
    },
  })
